import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const FormId = iotsUtils.fromList(constants.job.create.step.formIds);

export const Id = iotsUtils.fromList(constants.job.create.step.ids);
